import { render, staticRenderFns } from "./Leads.vue?vue&type=template&id=680c304e&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"
import style0 from "./Leads.vue?vue&type=style&index=0&id=680c304e&prod&lang=scss&scoped=true"
import style1 from "./Leads.vue?vue&type=style&index=1&id=680c304e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.24_css-loader@6.11.0_webpack@5.103.0__lodash@4_02e380aa463220c29513590f381609d6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c304e",
  null
  
)

export default component.exports